export default __webpack_public_path__ + "static/media/game-analytics.0b590480.svg";